import axios from "axios";
import { API_URL } from "src/enviroment/enviroment";
import jwt_decode from "jwt-decode";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// add request interceptor
api.interceptors.request.use(
  (config) => {
    let accessToken = localStorage.getItem("auth");
    if (!config.headers["Authorization"] && accessToken) {
      config.headers["Authorization"] = `Bearer ${JSON.parse(accessToken)}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    let refreshToken = localStorage.getItem("refreshToken");

    if (refreshToken) {
      let decodedToken = jwt_decode(refreshToken);

      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp < currentTime) {
        localStorage.clear(); // Clear all local storage values
        window.location.href = "/login";
        return Promise.reject(error);
      } else {
        const prevRequest = error?.config;

        if (
          (error?.response?.status === 401 ||
            error?.response?.status === 403) &&
          !prevRequest?.sent
        ) {
          prevRequest.sent = true;

          const response = await api.get("/auth/new-access-token", {
            headers: {
              Authorization: `Bearer ${JSON.parse(refreshToken)}`,
            },
          });

          if (response?.data?.newAccessToken) {
            localStorage.setItem(
              "auth",
              JSON.stringify(response.data.newAccessToken)
            );
            prevRequest.headers[
              "Authorization"
            ] = `Bearer ${response.data.newAccessToken}`;
            return api(prevRequest);
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
